/**
 * Rutas Pro aisladas — editar sin afectar el bundle de rutas Starter.
 */
import { clubRouteElements } from '@/soluqr/modules/club/pages';

/** @type {Array<{ segment: string, element: import('react').ReactElement }>} */
export const PRO_DASHBOARD_ROUTE_ELEMENTS = [...clubRouteElements];
